/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SubjectUrnTypeEnum = "Email" | "Integration" | "Org" | "Person" | "Phone" | "Services" | "Team" | "User" | "%future added value";
export type RemoveOrgTagsMutationInput = {
    clientMutationId?: string | null | undefined;
    eventParentRelayId: string;
    orgRelayId: string;
    tagNames: Array<string>;
};
export type RemoveUserTagsMutationVariables = {
    input: RemoveOrgTagsMutationInput;
};
export type RemoveUserTagsMutationResponse = {
    readonly removeOrgTags: {
        readonly eventParent: {
            readonly events: ReadonlyArray<{
                readonly annotatedEvent: {
                    readonly id: string;
                    readonly externalEventId: string | null;
                    readonly userTags: ReadonlyArray<{
                        readonly tag: string;
                        readonly states: ReadonlyArray<{
                            readonly value: string | null;
                            readonly subjectType: SubjectUrnTypeEnum;
                            readonly subjectValue: string;
                            readonly lastModified: number;
                            readonly active: boolean;
                        }> | null;
                    }> | null;
                } | null;
                readonly annotatedRecurringEvent: {
                    readonly id: string;
                    readonly externalEventId: string | null;
                    readonly userTags: ReadonlyArray<{
                        readonly tag: string;
                        readonly states: ReadonlyArray<{
                            readonly value: string | null;
                            readonly subjectType: SubjectUrnTypeEnum;
                            readonly subjectValue: string;
                            readonly lastModified: number;
                            readonly active: boolean;
                        }> | null;
                    }> | null;
                } | null;
            }>;
        } | null;
    } | null;
};
export type RemoveUserTagsMutation = {
    readonly response: RemoveUserTagsMutationResponse;
    readonly variables: RemoveUserTagsMutationVariables;
};



/*
mutation RemoveUserTagsMutation(
  $input: RemoveOrgTagsMutationInput!
) {
  removeOrgTags(input: $input) {
    eventParent {
      events {
        annotatedEvent {
          id
          externalEventId
          userTags {
            tag
            states {
              value
              subjectType
              subjectValue
              lastModified
              active
            }
          }
        }
        annotatedRecurringEvent {
          id
          externalEventId
          userTags {
            tag
            states {
              value
              subjectType
              subjectValue
              lastModified
              active
            }
          }
        }
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = [
        (v2 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalEventId",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "UserTag",
            "kind": "LinkedField",
            "name": "userTags",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tag",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "TagState",
                    "kind": "LinkedField",
                    "name": "states",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "subjectType",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "subjectValue",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastModified",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "active",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ], v4 = {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "events",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "AnnotatedEvent",
                "kind": "LinkedField",
                "name": "annotatedEvent",
                "plural": false,
                "selections": (v3 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "AnnotatedEvent",
                "kind": "LinkedField",
                "name": "annotatedRecurringEvent",
                "plural": false,
                "selections": (v3 /*: any*/),
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "RemoveUserTagsMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "RemoveOrgTagsMutationPayload",
                    "kind": "LinkedField",
                    "name": "removeOrgTags",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventParent",
                            "kind": "LinkedField",
                            "name": "eventParent",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "RemoveUserTagsMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "RemoveOrgTagsMutationPayload",
                    "kind": "LinkedField",
                    "name": "removeOrgTags",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventParent",
                            "kind": "LinkedField",
                            "name": "eventParent",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                (v2 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "cca15067b148dce722154d0e8469ccaf",
            "id": null,
            "metadata": {},
            "name": "RemoveUserTagsMutation",
            "operationKind": "mutation",
            "text": "mutation RemoveUserTagsMutation(\n  $input: RemoveOrgTagsMutationInput!\n) {\n  removeOrgTags(input: $input) {\n    eventParent {\n      events {\n        annotatedEvent {\n          id\n          externalEventId\n          userTags {\n            tag\n            states {\n              value\n              subjectType\n              subjectValue\n              lastModified\n              active\n            }\n          }\n        }\n        annotatedRecurringEvent {\n          id\n          externalEventId\n          userTags {\n            tag\n            states {\n              value\n              subjectType\n              subjectValue\n              lastModified\n              active\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '5f2629fd79e0f6da453f9e9ef16162b4';
export default node;
